module.exports = __webpack_public_path__ + "img/sidebar-icon-report.63adc9f9.svg";